"use client";

import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

const platforms = [
    {
        id: "tv",
        icon: "/downloads/TV.png",
        title: "TV",
        description: "نسخه مخصوص تلویزیون‌های هوشمند اندروید",
        requirements: "نیازمند Android TV 9 و بالاتر",
        size: "حجم ۱۹ مگابایت",
        downloadUrl: "https://webideh.com/idehnama/idehnama-tv.apk",
        tvOnly: true,
        markets: [
            { name: "بازار", icon: "/downloads/bazaar.png", url: "https://cafebazaar.ir/app/ir.idehnama.idehnamaapptv" },
        ],
    },
    {
        id: "ios",
        icon: "/downloads/ios.png",
        title: "iOS",
        description: "نسخه مخصوص آیفون و آیپد",
        requirements: "نیازمند iOS 14 و بالاتر",
        size: "حجم ۶۵ مگابایت",
        downloadUrl: "#",
        tvOnly: false,
        markets: [],
    },
    {
        id: "android",
        icon: "/downloads/android.png",
        title: "Android",
        description: "نسخه مخصوص موبایل و تبلت‌های اندرویدی",
        requirements: "نیازمند اندروید ۱۰ و بالاتر",
        size: "حجم ۲۵ مگابایت",
        downloadUrl: "https://webideh.com/idehnama/idehnama.apk",
        tvOnly: false,
        markets: [
            { name: "بازار", icon: "/downloads/bazaar.png", url: "https://cafebazaar.ir/app/ir.idehnama.idehnamaappphone" },
        ],
    },
    {
        id: "windows",
        icon: "/downloads/Windows.png",
        title: "Windows",
        description: "نسخه مخصوص ویندوز ۱۰ و ۱۱",
        requirements: "نیازمند Windows 10 64bit",
        size: "حجم ۳۳ مگابایت",
        downloadUrl: "https://webideh.com/idehnama/idehnama-windows.zip",
        tvOnly: false,
        markets: [],
    },
    {
        id: "linux",
        icon: "/downloads/linux.png",
        title: "Linux App",
        description: "نسخه مخصوص سیستم‌های لینوکسی",
        requirements: "Ubuntu 20.04 و بالاتر",
        size: "حجم ۱۲ مگابایت",
        downloadUrl: "https://webideh.com/idehnama/idehnama-linux.tar.gz",
        tvOnly: false,
        markets: [],
    },
];

const DownloadIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.9805 0.000142822C11.6271 0.00531787 11.2902 0.15047 11.0438 0.403705C10.7975 0.656941 10.6618 0.997543 10.6667 1.35067V14.1221L8.94274 12.3995C8.81988 12.2716 8.67272 12.1696 8.50988 12.0992C8.34705 12.0289 8.1718 11.9917 7.99442 11.9899C7.81703 11.9881 7.64107 12.0217 7.47683 12.0887C7.3126 12.1557 7.16339 12.2548 7.03795 12.3801C6.91252 12.5055 6.81337 12.6546 6.74632 12.8187C6.67927 12.9828 6.64566 13.1586 6.64746 13.3359C6.64927 13.5131 6.68645 13.6882 6.75683 13.851C6.82721 14.0137 6.92938 14.1607 7.05734 14.2835L11.0573 18.2804C11.3074 18.5302 11.6464 18.6705 12 18.6705C12.3536 18.6705 12.6926 18.5302 12.9427 18.2804L16.9426 14.2835C17.0706 14.1607 17.1728 14.0137 17.2432 13.851C17.3135 13.6882 17.3507 13.5131 17.3525 13.3359C17.3543 13.1586 17.3207 12.9828 17.2537 12.8187C17.1866 12.6546 17.0875 12.5055 16.962 12.3801C16.8366 12.2548 16.6874 12.1557 16.5232 12.0887C16.3589 12.0217 16.183 11.9881 16.0056 11.9899C15.8282 11.9917 15.6529 12.0289 15.4901 12.0992C15.3273 12.1696 15.1801 12.2716 15.0573 12.3995L13.3333 14.1221V1.35067C13.3358 1.17253 13.3024 0.995715 13.2353 0.830675C13.1681 0.665635 13.0686 0.515725 12.9424 0.389811C12.8163 0.263897 12.6662 0.164537 12.5009 0.0976062C12.3357 0.0306757 12.1587 -0.00246547 11.9805 0.000142822ZM1.31391 16.6541C0.960523 16.6592 0.623643 16.8044 0.377297 17.0576C0.130951 17.3109 -0.00470929 17.6515 0.000124905 18.0046V20.0031C0.000124905 22.1947 1.80675 24 4.00008 24H19.9999C22.1932 24 23.9999 22.1947 23.9999 20.0031V18.0046C24.0024 17.828 23.9697 17.6528 23.9038 17.4889C23.838 17.3251 23.7401 17.176 23.6161 17.0503C23.492 16.9245 23.3442 16.8247 23.1812 16.7565C23.0182 16.6884 22.8432 16.6533 22.6665 16.6533C22.4898 16.6533 22.3149 16.6884 22.1519 16.7565C21.9889 16.8247 21.8411 16.9245 21.717 17.0503C21.593 17.176 21.4951 17.3251 21.4293 17.4889C21.3634 17.6528 21.3307 17.828 21.3332 18.0046V20.0031C21.3332 20.7545 20.7519 21.3354 19.9999 21.3354H4.00008C3.24811 21.3354 2.66676 20.7545 2.66676 20.0031V18.0046C2.6692 17.8265 2.63587 17.6496 2.56873 17.4846C2.50159 17.3196 2.402 17.1696 2.27587 17.0437C2.14974 16.9178 1.99963 16.8185 1.8344 16.7515C1.66917 16.6846 1.49218 16.6515 1.31391 16.6541Z" fill="white" />
    </svg>
);

// Wrapper for disabled buttons — shows "به زودی" badge on hover
// small=true برای دکمه‌های کوچک مثل مایکت/بازار (48×48)
const ComingSoonWrapper = ({ children, className = "", small = false }: { children: React.ReactNode; className?: string; small?: boolean }) => (
    <div className={`relative group/soon ${className}`}>
        <div className="pointer-events-none select-none opacity-50">{children}</div>
        <div className="absolute inset-0 flex items-center justify-center rounded-lg opacity-0 group-hover/soon:opacity-100 transition-opacity duration-200"
            style={{ background: "rgba(0,0,0,0.72)" }}>
            <span
                className="font-bold rounded-full"
                style={{
                    background: "linear-gradient(90deg,#EB3485,#851D4B)",
                    color: "#fff",
                    whiteSpace: "nowrap",
                    fontSize: small ? "9px" : "12px",
                    padding: small ? "2px 4px" : "4px 8px",
                }}
            >
                به زودی
            </span>
        </div>
    </div>
);

// PWA guide modal for iOS
const PwaModal = ({ onClose }: { onClose: () => void }) => (
    <div
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        style={{ background: "rgba(0,0,0,0.75)" }}
        onClick={onClose}
    >
        <div
            dir="rtl"
            className="relative w-full max-w-md rounded-2xl p-6 text-right"
            style={{ background: "#080F1B", border: "1px solid rgba(143,143,143,0.3)" }}
            onClick={(e) => e.stopPropagation()}
        >
            {/* close */}
            <button
                onClick={onClose}
                className="absolute top-4 left-4 text-white/50 hover:text-white transition-colors text-xl leading-none"
                aria-label="بستن"
            >
                ✕
            </button>

            <h3 className="text-white font-bold text-lg mb-1">نصب اپلیکیشن iOS</h3>
            <p className="text-white/50 text-sm mb-5">
                با افزودن سایت به صفحه اصلی آیفون، تجربه‌ای شبیه به اپ بومی داشته باشید.
            </p>

            <ol className="flex flex-col gap-4">
                {[
                    {
                        step: "۱",
                        title: "سافاری را باز کنید",
                        desc: "مرورگر Safari را روی آیفون یا آیپد خود باز کنید و به آدرس سایت بروید.",
                        icon: "🧭",
                    },
                    {
                        step: "۲",
                        title: "دکمه اشتراک‌گذاری را بزنید",
                        desc: 'آیکون Share (مربع با فلش رو به بالا) را در نوار پایین سافاری لمس کنید.',
                        icon: "⬆️",
                    },
                    {
                        step: "۳",
                        title: "«Add to Home Screen» را انتخاب کنید",
                        desc: "در منوی باز شده، گزینه «Add to Home Screen» یا «افزودن به صفحه اصلی» را پیدا و انتخاب کنید.",
                        icon: "➕",
                    },
                    {
                        step: "۴",
                        title: "تأیید کنید",
                        desc: "نام دلخواه را وارد کنید و روی «Add» یا «اضافه کردن» بزنید.",
                        icon: "✅",
                    },
                ].map(({ step, title, desc, icon }) => (
                    <li key={step} className="flex gap-3 items-start">
                        <span className="text-2xl leading-none mt-0.5">{icon}</span>
                        <div>
                            <p className="text-white font-bold text-sm">{title}</p>
                            <p className="text-white/50 text-xs leading-relaxed mt-0.5">{desc}</p>
                        </div>
                    </li>
                ))}
            </ol>

            <button
                onClick={onClose}
                className="mt-6 w-full py-3 rounded-xl font-bold text-white text-sm transition-opacity hover:opacity-90"
                style={{ background: "linear-gradient(90deg,#EB3485,#851D4B)" }}
            >
                متوجه شدم
            </button>
        </div>
    </div>
);

const PlatformCard = ({
    platform,
    onIosClick,
}: {
    platform: typeof platforms[number];
    onIosClick: () => void;
}) => (
    <div
        className="flex flex-col w-full p-4 sm:p-6"
        style={{
            background: "#080F1B",
            border: "1px solid rgba(143,143,143,0.5)",
            borderRadius: "16px",
            maxWidth: "528px",
        }}
    >
        {/* header: title + icon */}
        <div className="flex items-center justify-between gap-3 mb-2">
            <div className="flex flex-col flex-1 text-right min-w-0">
                <h3 className="text-white truncate" style={{ fontWeight: 800, fontSize: "clamp(18px,4vw,24px)" }}>
                    {platform.title}
                </h3>
                <p className="text-white/80 leading-snug" style={{ fontWeight: 800, fontSize: "clamp(12px,3vw,16px)" }}>
                    {platform.description}
                </p>
            </div>
            <div className="relative flex-shrink-0" style={{ width: "clamp(80px,20vw,120px)", height: "clamp(80px,20vw,120px)" }}>
                <Image src={platform.icon} alt={platform.title} fill className="object-contain" />
            </div>
        </div>

        {/* meta */}
        <p className="text-white/50 text-right" style={{ fontSize: "13px" }}>{platform.requirements}</p>
        <p className="text-white/50 text-right mb-4" style={{ fontSize: "13px" }}>{platform.size}</p>

        {/* buttons — wrap on small screens */}
        <div className="flex flex-wrap items-center gap-2">
            {/* نسخه نمایش خانگی — disabled */}
            {platform.tvOnly && (
                <ComingSoonWrapper className="flex-1 min-w-[120px]">
                    <div
                        className="flex items-center justify-center font-bold w-full"
                        style={{
                            height: "44px",
                            background: "transparent",
                            border: "1px solid rgba(255,255,255,0.5)",
                            borderRadius: "8px",
                            fontSize: "12px",
                            fontWeight: 700,
                            color: "rgba(255,255,255,0.8)",
                        }}
                    >
                        نسخه نمایش خانگی
                    </div>
                </ComingSoonWrapper>
            )}

            {/* دانلود مستقیم */}
            {platform.id === "ios" ? (
                <button
                    onClick={onIosClick}
                    className="flex items-center justify-center gap-2 hover:opacity-90 transition-opacity flex-1 min-w-[130px] cursor-pointer"
                    style={{
                        height: "44px",
                        background: "linear-gradient(90deg, #EB3485 0%, #851D4B 100%)",
                        border: "1px solid rgba(255,255,255,0.5)",
                        borderRadius: "8px",
                        fontSize: "13px",
                        fontWeight: 700,
                    }}
                >
                    <span className="text-white font-bold me-1">راهنمای نصب</span>
                    <DownloadIcon />
                </button>
            ) : (
                <a
                    href={platform.downloadUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 hover:opacity-90 transition-opacity flex-1 min-w-[130px]"
                    style={{
                        height: "44px",
                        background: "linear-gradient(90deg, #EB3485 0%, #851D4B 100%)",
                        border: "1px solid rgba(255,255,255,0.5)",
                        borderRadius: "8px",
                        fontSize: "13px",
                        fontWeight: 700,
                    }}
                >
                    <span className="text-white font-bold me-1">دانلود مستقیم</span>
                    <DownloadIcon />
                </a>
            )}

            {/* بازار */}
            {platform.markets.map((market) => (
                <a
                    key={market.name}
                    href={market.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="relative flex items-center justify-center overflow-hidden flex-shrink-0 hover:opacity-90 transition-opacity"
                    style={{
                        width: "44px",
                        height: "44px",
                        border: "1px solid rgba(255,255,255,0.5)",
                        borderRadius: "8px",
                        background: "#111827",
                    }}
                >
                    <Image src={market.icon} alt={market.name} fill className="object-contain p-2" />
                </a>
            ))}
        </div>
    </div>
);

export default function AppsPageContent() {
    const [showPwaModal, setShowPwaModal] = useState(false);

    const row1 = platforms.slice(0, 3);
    const row2 = platforms.slice(3);

    return (
        <div dir="rtl" className="min-h-screen text-foreground">
            {showPwaModal && <PwaModal onClose={() => setShowPwaModal(false)} />}

            {/* Hero */}
            <section
                className="relative w-full flex flex-row items-stretch mt-16 overflow-hidden"
                style={{ minHeight: "320px", background: "linear-gradient(90deg, #01081B -1.93%, #0D0511 100%)" }}
            >
                <div className="flex-1 flex items-center justify-start px-6 sm:px-8 lg:px-16 py-10 sm:py-16 text-right">
                    <div className="max-w-md">
                        <h1
                            className="text-primary leading-tight mb-3"
                            style={{ fontWeight: 800, fontSize: "clamp(36px, 5vw, 64px)" }}
                        >
                            ایده نما ،
                        </h1>
                        <h2
                            className="text-white mb-4"
                            style={{ fontWeight: 800, fontSize: "clamp(18px, 2.2vw, 30px)" }}
                        >
                            تماشای بدون محدودیت
                        </h2>
                        <p
                            className="text-white/70 mb-8 leading-relaxed"
                            style={{ fontWeight: 400, fontSize: "clamp(13px, 1.1vw, 18px)" }}
                        >
                            ایده نما را روی تمام دستگاه‌های خود نصب کنید
                            <br />
                            و تجربه‌ای روان و سینمایی داشته باشید
                        </p>
                        <Link
                            href="/"
                            className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors"
                            style={{ fontWeight: 500, fontSize: "clamp(13px, 1.1vw, 18px)" }}
                        >
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 7V8V25H31V7H1ZM3 9H29V23H3V9ZM9 26L8.5 27.5H23.5L23 26.5C16.5 26 9 26 9 26Z" fill="white" />
                            </svg>
                            نسخه وب را امتحان کنید
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.0003 20.67C14.8103 20.67 14.6203 20.6 14.4703 20.45L7.95027 13.93C6.89027 12.87 6.89027 11.13 7.95027 10.07L14.4703 3.54999C14.7603 3.25999 15.2403 3.25999 15.5303 3.54999C15.8203 3.83999 15.8203 4.31999 15.5303 4.60999L9.01027 11.13C8.53027 11.61 8.53027 12.39 9.01027 12.87L15.5303 19.39C15.8203 19.68 15.8203 20.16 15.5303 20.45C15.3803 20.59 15.1903 20.67 15.0003 20.67Z" fill="white" />
                            </svg>
                        </Link>
                    </div>
                </div>

                <div
                    className="relative flex-shrink-0 hidden lg:block"
                    style={{ width: "1052px", height: "702px", maxWidth: "65vw", minHeight: "400px", maxHeight: "702px" }}
                >
                    <Image src="/downloads/backdrop.png" alt="backdrop" fill priority />
                </div>
            </section>

            {/* Platform Cards */}
            <section className="py-10 sm:py-16 px-4 sm:px-6" style={{ background: "linear-gradient(180deg, #040718 0%, #002435 100%)" }}>
                <h2
                    className="text-white text-center mb-8 sm:mb-10"
                    style={{ fontWeight: 800, fontSize: "clamp(18px, 2vw, 28px)" }}
                >
                    اپلیکیشن ایده‌نما برای همه پلتفرم‌ها
                </h2>

                {/* همه کارت‌ها در یک grid ریسپانسیو */}
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6 max-w-[1680px] mx-auto mb-4 sm:mb-6">
                    {row1.map((platform) => (
                        <PlatformCard key={platform.id} platform={platform} onIosClick={() => setShowPwaModal(true)} />
                    ))}
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-[1120px] mx-auto">
                    {row2.map((platform) => (
                        <PlatformCard key={platform.id} platform={platform} onIosClick={() => setShowPwaModal(true)} />
                    ))}
                </div>
            </section>
        </div>
    );
}
